import { AwardItem } from "@/app/main-header/data";
import Image from "next/image";
import { memo } from "react";

interface AwardCardProps {
  award: AwardItem;
}

const AwardCard = memo(({ award }: AwardCardProps) => {
  return (
    <div className="group flex justify-center items-center">
      <Image
        src={award.image}
        alt={award.name}
        width={135}
        height={115}
        sizes="(max-width:768px) 80px, (max-width:1200px) 100px, 135px"
        className="h-auto w-[80px] sm:w-[100px] md:w-[90px] lg:w-[115px] object-contain transition-transform duration-300 group-hover:scale-105"
        priority={false}
      />
    </div>
  );
});

AwardCard.displayName = "AwardCard";

export default AwardCard;
